import { Select as AntSelect } from 'antd';
import type { SelectProps } from 'antd/es/select';
import React from 'react';

export const { Option, OptGroup } = AntSelect;

export type Props = {
  relativePopupContainer?: (node: HTMLElement) => HTMLElement;
  useDefaultPopupContainer?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- legacy directive, needs investigation
} & SelectProps<any>;

export const Select = ({
  relativePopupContainer,
  useDefaultPopupContainer,
  children,
  ...props
}: Props) => {
  const additionalProps = useDefaultPopupContainer
    ? {}
    : {
        getPopupContainer:
          relativePopupContainer ||
          ((trigger: HTMLElement) => trigger.parentNode as HTMLElement),
      };

  return (
    <AntSelect {...additionalProps} {...props}>
      {children}
    </AntSelect>
  );
};
